import { FoodsBadge, FoodsTooltip } from "@foodpilot/foods";
import { Stack, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

export const CalculatorActionIcon = () => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <FoodsTooltip title={t("action.tooltip.calculator", "Impact calculated based on your inputs.")}>
            <Stack>
                <FoodsBadge
                    size={3}
                    icon={"calculate"}
                    boxProps={{
                        sx: {
                            backgroundColor: theme.custom.dataviz.colorsWithExtra[15].variant[100],
                            borderRadius: theme.spacing(0.5),
                        },
                    }}
                    boxExtraPaddingPx={0}
                />
            </Stack>
        </FoodsTooltip>
    );
};
